module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_BlackMatted.65339fb9.jpg";